module.exports = __webpack_public_path__ + "static/media/Pancakes.352af9c0.svg";